<template>
  <DialogLayout
    ref="formDialog"
    :maxWidth="maxWidth"
    :title="title"
    :btnAlign="btnAlign"
    @close="_dialogAction"
    eager
    :loading="formLoading"
    :cardContentClass="cardContentClass"
    :enableCancel="enableCancel"
    :confirmBtnText="confirmBtnText"
    :cancelBtnText="cancelBtnText"
    :isCancelDelete="isCancelDelete"
    disableCloseHide
  >
    <v-form class="mt-4" :ref="formRef" @submit.prevent>
      <slot></slot>
    </v-form>
  </DialogLayout>
</template>

<script>
import DialogLayout from '@/components/layout/DialogLayout.vue'
export default {
  name: 'FormDialog',
  components: {
    DialogLayout,
  },
  props: {
    formRef: {
      type: String,
      required: true,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    maxWidth: {
      type: Number,
      default: 910,
    },
    btnAlign: {
      type: String,
      default: 'start',
    },
    cardContentClass: {
      type: String,
      default: '',
    },
    enableCancel: {
      type: Boolean,
      required: false,
      default: false,
    },
    confirmBtnText: {
      type: String,
      required: false,
      default: 'confirm',
    },
    cancelBtnText: {
      type: String,
      required: false,
      default: 'cancel',
    },
    disableCloseHide: {
      type: Boolean,
      required: false,
      default: false,
    },
    isCancelDelete: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data: () => ({
    formLoading: false,
    resolvePromise: undefined,
    info: null,
  }),
  methods: {
    show() {
      this.$refs.formDialog.show()

      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve
      })
    },
    hide() {
      this.$refs.formDialog.hide()
      this.formLoading = false
      this.setInfo(null)
    },
    setLoading(loading) {
      this.formLoading = loading
    },
    async resetForm() {
      await this.$refs[this.formRef].reset()
    },
    setInfo(value = null) {
      this.info = value
    },
    getInfo() {
      return this.info
    },

    async _dialogAction(action) {
      if (this.formLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      if (action === true) {
        const valid = await this.$refs[this.formRef].validate()
        if (!valid) {
          this.$store.dispatch('toggleSnack', { message: 'required' })
          return
        }

        this.formLoading = true
        if (this.resolvePromise) {
          this.resolvePromise(true)
        }
      } else {
        if (!this.disableCloseHide) {
          this.hide()
        }
        if (this.resolvePromise) {
          this.resolvePromise(action)
        }
      }
    },
  },
}
</script>
